import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BlackRightArrow = ({ className }) => {
    return (_jsxs("svg", { viewBox: "0 0 24 8", className: className, children: [_jsx("path", { fill: "lightGray", d: "M0 4h21.6 M20 8l4-4l-4-4V8z" }), _jsx("path", { fill: "lightGray", stroke: "lightGray", strokeWidth: "2", d: "M0 4h21.6" })] }));
};
export default BlackRightArrow;
//# sourceMappingURL=BlackRightArrow.js.map